export const FLAG_GETTING_PARCEL_PRICES = 'FLAG_GETTING_PARCEL_PRICES';
export const GET_PARCEL_PRICES = 'GET_PARCEL_PRICES';
export const CLEAR_PARCEL_PRICES = 'CLEAR_PARCEL_PRICES';
export const FLAG_PARCEL_PRICE_ACTIVITY = 'FLAG_PARCEL_PRICE_ACTIVITY';
export const GET_PARCEL_PRICE = 'GET_PARCEL_PRICE';
export const CLEAR_PARCEL_PRICE = 'CLEAR_PARCEL_PRICE';
